/**
 * Malagasy ariary.
 */
export var MGA = {
  code: 'MGA',
  base: 5,
  exponent: 1
};